import { useMemo } from 'react';
import { AuditReport } from '../digital-audit-constants';
import { renderGuideHtml } from '../engine/journey-guide-utils';

interface ClientGuideViewProps {
  report: AuditReport | null;
}

export const ClientGuideView = ({ report }: ClientGuideViewProps) => {
  const html = useMemo(() => (report ? renderGuideHtml(report.journey) : ''), [report]);

  if (!report) {
    return (
      <div className='digital-audit-page'>
        <div className='digital-audit-empty-state'>Run a scan to generate the client guide.</div>
      </div>
    );
  }

  return (
    <div className='digital-audit-page'>
      <iframe
        className='digital-audit-client-guide-view'
        title='Client guide'
        srcDoc={html}
        sandbox=''
      />
    </div>
  );
};
